export default "__VITE_ASSET__2EYELD_A__"